// eslint-disable-next-line no-restricted-imports
import { TargetedFinancialInstrumentsFragment } from 'api/generated/graphql';
import { LegalClientTargetedFinancialInstrumentsEntity } from 'api/types/entity/legal/legalClientTargetedFinancialInstrumentsEntity';

export const parseLegalClientTargetedFinancialInstrumentsEntity = (
  data: TargetedFinancialInstrumentsFragment
): LegalClientTargetedFinancialInstrumentsEntity => ({
  operationsDetails: data.operationsDetails,
  financialInstruments: data.financialInstruments,
});
